import { Model } from 'pinia-orm';
import Company from './Company';
import EmailTemplateAttachment from './EmailTemplateAttachment';

export default class EmailTemplate extends Model {

    static get entity() {
        return 'email-templates';
    }

    get isDefaultAutoReply() {
        return this.type == 'auto_reply' && this.default;
    }

    static fields() {
        return {
            id: this.uid(),
            type: this.string('general'),
            default: this.boolean(false),
            order: this.number(0),
            name: this.attr({}),
            subject: this.attr({}),
            content: this.attr({}),
            confirmation_subject: this.attr({}),
            confirmation_content: this.attr({}),
            queued_attachments: this.attr({}),
            company_id: this.attr(null),

            company: this.belongsTo(Company, 'company_id'),

            //relationships
            attachments: this.hasMany(EmailTemplateAttachment, 'template_id'),
        };
    }
}
